import store from "../store/index";
//------------------------
// get sub-status options
//------------------------
export default function getSubStatusOptions(cur_sub_status) {
  //----------------------
  // get all sub-statuses
  //----------------------
  const this_store = store;
  const statuses = this_store.getters["combat/getStatuses"];
  //-------------------------------------------
  // get available sub-statuses (excl current)
  //-------------------------------------------
  let avail_sub_statuses = statuses.filter(
    (a) => a.sub_status != cur_sub_status
  );
  return avail_sub_statuses;
}
